export default __webpack_public_path__ + "static/media/kenlo.ee522105.svg";